import { clientCases as coreCases } from './clientCases'
import { clientCasesPart2 } from './clientCasesPart2'
import { webappCases } from './webappCases'
import type { ClientCase, ContentBlock } from './clientCases'

// Alle cases samengevoegd, nog ongesorteerd
const combined: ClientCase[] = [...coreCases, ...clientCasesPart2, ...webappCases]

// Afbeeldingen die we achteraf vervangen zonder het bronbestand te herschrijven
const heroImageOverrides: Record<string, string> = {
  'mynt-schoonmaak':
    'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=800&h=500&fit=crop',
}

// Expliciete volgorde waarin de cases getoond worden.
// Fysiotherapiepraktijk CG staat op plek 3, FCG Adviesgroep schuift door naar 4.
// De overige nieuwe klanten staan gerangschikt naar omvang van hun website.
// Hulphondenforum (webapplicatie) staat op plek 5, net voor De Haar School.
const displayOrder: string[] = [
  'overnamehuys',
  'daily-crew',
  'fysiotherapiepraktijk-cg',
  'fcg-adviesgroep',
  'hulphondenforum',
  'de-haar-school',
  '5-stars-events',
  'alex-construct',
  'gymfit-de-noord',
  'mijn-bedrijfs-waarderingen',
  'aurora-swimming',
  'flow-frl',
  'asfamily-fitness-center',
  'ars-cleanex',
  'de-tuinvrouw',
  'steenhuisvisuals',
  'tommys-services-security',
  'mynt-schoonmaak',
  'met-carla',
  'common-frame-media',
  'jaepie-jaepie',
]

const withOverrides = combined.map((c) =>
  heroImageOverrides[c.slug]
    ? { ...c, heroImage: heroImageOverrides[c.slug] }
    : c,
)

// Sorteer volgens displayOrder. Cases die niet in de lijst staan komen achteraan.
export const clientCases: ClientCase[] = [...withOverrides].sort((a, b) => {
  const ai = displayOrder.indexOf(a.slug)
  const bi = displayOrder.indexOf(b.slug)
  if (ai === -1 && bi === -1) return 0
  if (ai === -1) return 1
  if (bi === -1) return -1
  return ai - bi
})

export const getClientCaseBySlug = (slug: string): ClientCase | undefined => {
  return clientCases.find((c) => c.slug === slug)
}

export const getClientCasesBySector = (sector: string): ClientCase[] => {
  return clientCases.filter((c) => c.sector === sector)
}

export type { ClientCase, ContentBlock }
